module.exports = __webpack_public_path__ + "assets/img/3_1408.0b90cbc4.jpg";